import { FETCH_STATE_FAILURE, FETCH_STATE_REQUEST, FETCH_STATE_SUCCESS } from "../actions/types";

const initialState = {
    data: [],
    error: ''
};

export const posStateReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_STATE_REQUEST:
            return {
                ...state,
            }
        case FETCH_STATE_SUCCESS:
            return {
                data: action.payload
            }
        case FETCH_STATE_FAILURE:
            return {
                data: [],
                error: action.payload
            }
        default:
            return state;
    }
}